import React from 'react'
// removed import of scss-style

interface ProgressProps {
	deleteFile: (string) => void
	filename: string
	onUploadProgress: (progressEvent: unknown) => void
	successfullUploaded: boolean
	uploading: boolean
	uploadProgress: { state: string; percentage: number }
}

const ProgressContainer: React.FC<ProgressProps> = ({
	deleteFile,
	filename,
	uploadProgress
}: ProgressProps) => {
	const error_text =
		'Unsupported file. File must be of type PDF and 5MB or smaller.'
	const isError = uploadProgress.state === 'error'
	const isDone = uploadProgress.state === 'done'
	return (
		<div className="ProgressWrapper">
			<img
				onClick={e => deleteFile(filename)}
				className="DeleteIcon"
				alt="delete"
				src="/delete-icon.png"
				style={{
					opacity: ['done', 'error'].includes(uploadProgress.state) ? 1 : 0
				}}
			/>
			<Progress
				progress={uploadProgress.percentage}
				state={uploadProgress.state}
			/>
			<img
				className="CheckIcon"
				alt="done"
				src="/baseline-check_circle_outline-24px.svg"
				style={{
					opacity: isDone ? 0.5 : 0,
					display: isDone ? 'block' : 'none'
				}}
			/>

			<div
				className="tooltip"
				style={{
					opacity: isError ? 1 : 0,
					display: isError ? 'block' : 'none'
				}}>
				<img
					className="WarningIcon"
					style={{
						display: isError ? 'block' : 'none'
					}}
					src="/yellow-warning-sign.png"
					alt="warning!"></img>
				<span className="tooltiptext">{error_text}</span>
			</div>
		</div>
	)
}

interface ProgProps {
	progress: number
	state: string
}

const Progress: React.FC<ProgProps> = ({ progress, state }: ProgProps) => {
	let cssName = 'Progress'
	if (state === 'error') {
		cssName = 'Progress-failed'
	}
	return (
		<div className="ProgressBar">
			<div className={cssName} style={{ width: progress + '%' }} />
		</div>
	)
}

export default ProgressContainer
